class YGScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

class YGTabReviews extends YGScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    const swiperDom_1 = this.querySelector('.new-reviews-tab');
    const swiperDom_2 = this.querySelector('.new-reviews-content');

    var swiper = new Swiper(swiperDom_1, {
      direction: 'vertical',
      spaceBetween: 50,
      slidesPerView: 4,
      loop: true,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(swiperDom_2, {
      spaceBetween: 30,
      loop: true,
      autoplay: {
          delay: 2500,
          disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: swiper,
      },
    });
    if(window) {
      window.ygCusSwiper1 = swiper;
      window.ygCusSwiper2 = swiper2;
    }
    const mediaBtn = this.querySelectorAll('.yg-media-box-item');
    const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
    const mediaSection = this.querySelectorAll('.yg-media-box-section');
    const mediaClose = this.querySelectorAll('.yg-media-close');

    function toggleVideoPopup(index, action) {
      mediaPopup[index].classList[action]('hide');
      mediaSection[index]?.classList[action]('hide');
      mediaClose[index].classList[action]('hide');
      if(action === 'remove') {
        let innerHTML = mediaSection[index].innerHTML;
        mediaSection[index].innerHTML = innerHTML
      }
    }

    mediaBtn.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        console.log("dad")
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaClose.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'add');
        event.stopPropagation();
      });
    });

    document.addEventListener('click', function (event) {
      const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
      const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));

      if (!isClickedInsideBox && !isClickedInsideBtn) {
        mediaPopup.forEach((popup, index) => {
          // popup.classList.add('hide');
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      }
    });

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素已进入视口
          mediaPopup.forEach(item => {
            const iframeEles = item.querySelectorAll('iframe');
            iframeEles.forEach(iframe => {
              const src = iframe.getAttribute('yg-src');
              iframe.setAttribute('src', src);
              iframe.removeAttribute('yg-src');
            })
          })
          // 如果只需要执行一次，可以停止观察
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      // 配置观察选项
      threshold: 0.1, // 当至少50%的元素出现在视口中时，回调函数会被调用
    });
    
    // 选择要观察的目标元素
    const target = this;
    
    // 开始观察目标元素
    observer.observe(target);
  }
}

if (!window.customElements.get('yg-tab-reviews')) {
  window.customElements.define('yg-tab-reviews', YGTabReviews)
}

class YG3DSlideshow extends YGScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    const swiperEle = this.querySelector('.swiper');
    new Swiper(swiperEle, {
      loop: false,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1000: {
          slidesPerView: this.getAttribute('data-swiper-num'),
          spaceBetween: 30
        },
        700: {
          slidesPerView: 1,
          spaceBetween: 16,
        }
      }
    })

    const mediaBtn = this.querySelectorAll('.yg-media-box-item');
    const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
    const mediaSection = this.querySelectorAll('.yg-media-box-section');
    const mediaClose = this.querySelectorAll('.yg-media-close');

    function toggleVideoPopup(index, action) {
      mediaPopup[index].classList[action]('hide');
      mediaSection[index]?.classList[action]('hide');
      mediaClose[index].classList[action]('hide');
      if(action === 'remove') {
        let innerHTML = mediaSection[index].innerHTML;
        mediaSection[index].innerHTML = innerHTML
      }
    }

    mediaBtn.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaClose.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'add');
        event.stopPropagation();
      });
    });

    document.addEventListener('click', function (event) {
      const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
      const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));

      if (!isClickedInsideBox && !isClickedInsideBtn) {
        mediaPopup.forEach((popup, index) => {
          // popup.classList.add('hide');
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      }
    });
  }
}

if (!window.customElements.get('yg-3d-slideshow')) {
  window.customElements.define('yg-3d-slideshow', YG3DSlideshow)
}

class AddToCart extends YGScriptLoader {
  constructor() {
    super()
    this.clickBtn()
  }
  clickBtn() {
    // 这里放置自定义逻辑
    const AddBtn = document.querySelector('.shopify-section--main-product .product-info__buy-buttons button[type="submit"]') || this.parentNode.parentNode.parentNode.querySelector('.product-info__buy-buttons button[type="submit"]');
    this.addEventListener("click", function () {
      // Add to cart logic
      AddBtn.click();
    });
  }
}

class buyItNowBtn extends YGScriptLoader {
  constructor() {
    super()
    this.addEventListener("click", function () {
      this.clickBtn()
    });
  }
  clickBtn() {
    // 这里放置自定义逻辑
    let buyBtn = document.querySelector('.shopify-section--main-product .product-info__buy-buttons .shopify-payment-button .shopify-payment-button__more-options') || this.parentNode.parentNode.parentNode.querySelector('.product-info__buy-buttons .shopify-payment-button .shopify-payment-button__more-options');

    if (!buyBtn) {
      requestAnimationFrame(this.clickBtn())
    } else {

      // Buy it now logic
      buyBtn.click();

    }
  }
}

if (!window.customElements.get('buy-it-now')) {
  window.customElements.define('buy-it-now', buyItNowBtn)
}

if (!window.customElements.get('add-to-cart')) {
  window.customElements.define('add-to-cart', AddToCart)
}

class Tab extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const ygProductTab = this.querySelectorAll('.yg-tab-frame li');
    const ygTabBox = this;
    const ygBtnBox = this.querySelector('.yg-tab-button');
    const ygBtn = this.querySelector('.yg-add-to-cart');
    const ygSectionList = document.querySelectorAll('#main .shopify-section');
    const ygProductTabContainer = this.querySelector('.yg-tab-frame');

    ygProductTab.forEach(function (e) {
      e.onclick = function () {
        // 获取点击项的data-point属性值
        let point = e.getAttribute('data-point');
        let number = e.getAttribute('data-section-number');
        // 遍历ygProductTab，移除所有激活类
        ygProductTab.forEach((a) => {
          a.classList.remove('active');
        });
        // 给当前点击项添加激活类
        // e.classList.add('active');
        if (number) {
          // 通过属性值获取dom节点
          let pointDom = ygSectionList[number];
          // 计算滚动距离
          console.log(parseInt(ygTabBox.style.top), ygTabBox.getBoundingClientRect().height, pointDom.offsetTop);
          let pointTop =
            pointDom.offsetTop - (parseInt(ygTabBox.style.top) || 0) - ygTabBox.getBoundingClientRect().height - 50;
          // 滑动到指定dom节点
          window.scrollTo({
            top: pointTop,
            behavior: 'smooth',
          });
        }
      };
    });
    // 添加点击事件监听器
    ygBtn?.addEventListener('click', function () {
      if(ygBtn.classList.contains('yg-buy-it-now') == false) {
        let addToCart = document.querySelector('.yg-product-addtocart');
        console.log(addToCart);
        addToCart.click();
      } else if(ygBtn.classList.contains('yg-buy-it-now')){
        let buyItNow = document.querySelector('.yg-product-buyitnow');
        console.log(buyItNow);
        buyItNow.click();
      }
    });
    let scrollTimer;

    // 添加滚动事件监听器
    window.addEventListener('scroll', function () {
      // 清除之前的定时器
      clearTimeout(scrollTimer);

      // 设置新的定时器
      scrollTimer = setTimeout(function () {
        // 在页面滚动停止后执行的操作
        const headerSection = document.querySelector('header.shopify-section--header');
        let { height, top } = headerSection.getBoundingClientRect();
        // 剩下的代码保持不变
        if (headerSection) {
          let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;

          if(!ygTabBox.parentNode.style.top){
            ygTabBox.parentNode.style.position = 'sticky';
            ygTabBox.parentNode.style.top = btnBoxTop + 'px';
            // ygTabBox.parentNode.style.zIndex = '10';
          }
          ygTabBox.style.top = btnBoxTop + 'px';

          if (ygTabBox.getBoundingClientRect().top <= btnBoxTop+5) {
            ygBtnBox.style.width = '340px';
          } else {
            ygBtnBox.style.width = 0;
          }
        }
      }, 250); // 这里的 250 是延迟时间，单位为毫秒
    });

    const variantBlock = document.querySelector('.variant-picker');
      const priceEle = this.querySelector('.price-list')
      variantBlock?.addEventListener('click', (event) => {
        if (event.target !== variantBlock) {
          setTimeout(() => {
            const newElement = document.querySelector('.product-info .price-list')
            priceEle.innerHTML = newElement.innerHTML
          }, 1000);
        }
      })

    // const options = {
    //   threshold: [0.5]
    // }

    const debounce = (func, delay) => {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    };

    // const intersectionObserver = new IntersectionObserver((entries) => {
    //   if ((entries[0].intersectionRatio > 0.5) || (window.innerHeight < entries[0].target.offsetHeight)) {
    //     console.log(entries[0].target.getAttribute('data-section-number'),'data-section-number',entries[0].target.height);
    //     ygProductTab.forEach((productTab) => {
    //       if(entries[0].target.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
    //         ygProductTab.forEach((ele) => {
    //           ele.classList.remove('active')
    //         })
    //         scrollProductTabContainer(productTab.offsetLeft);
    //         productTab.classList.add('active');
    //       }
    //     })
    //   }
    // }, options)

    const windowHeight = window.innerHeight

    window.addEventListener('scroll', () => {
      ygSectionList.forEach((item)=>{
        if(item.getBoundingClientRect().top - (windowHeight * 2/3) < 0){
          ygProductTab.forEach((productTab) => {
            if(item.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
              ygProductTab.forEach((ele) => {
                ele.classList.remove('active')
              })
              scrollProductTabContainer(productTab.offsetLeft);
              productTab.classList.add('active');
            }
          })
        }
      })
    })

    const scrollProductTabContainer = debounce((left) => {
      ygProductTabContainer.scrollTo({ left, behavior: 'smooth' });
    }, 300);

    ygSectionList.forEach(function (Section,i){
      Section.setAttribute("data-section-number", i)
      // intersectionObserver.observe(Section);
    })
  }
}

if (!window.customElements.get('yg-tab')) {
  window.customElements.define('yg-tab', Tab)
}

class YGMultiMedia extends YGScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    const navElementsContainer = this.querySelector('.yg-nav');
    const navElements = this.querySelectorAll('.yg-nav-item');
    const contentElements = this.querySelectorAll('.yg-content');
    let activeIndex = 0;

    navElements.forEach((navElement, index) => {
      navElement.addEventListener('click', () => {
        navElements[activeIndex].classList.remove('active');
        contentElements[activeIndex].classList.add('hide');

        activeIndex = index;

        navElements[activeIndex].classList.add('active');
        contentElements[activeIndex].classList.remove('hide');

         // 计算点击标签的位置和宽度
        const itemRect = navElement.getBoundingClientRect();
        const itemWidth = itemRect.width;
        const itemLeft = itemRect.left;

        // 计算导航栏容器的宽度和中心位置
        const containerRect = navElementsContainer.getBoundingClientRect();
        const containerWidth = containerRect.width;
        const containerCenter = containerRect.left + containerWidth / 2;

        // 计算偏移量
        const offset = itemLeft + itemWidth / 2 - containerCenter;

        // 平滑滚动到目标位置
        navElementsContainer.scrollTo({
          left: navElementsContainer.scrollLeft + offset,
          behavior: 'smooth'
        });
      })
    });

    navElements[activeIndex].classList.add('active');
    contentElements[activeIndex].classList.remove('hide');

    const mediaBtn = this.querySelectorAll('.hide_pc .yg-media-box-item');
    const mediaBtn_mb = this.querySelectorAll('.hide_mb .yg-media-box-item');
    const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
    const mediaSection = this.querySelectorAll('.yg-media-box-section');
    const mediaClose = this.querySelectorAll('.yg-media-close');

    function toggleVideoPopup(index, action) {
      mediaPopup[index].classList[action]('hide');
      mediaSection[index]?.classList[action]('hide');
      mediaClose[index].classList[action]('hide');
      if(action === 'remove') {
        let innerHTML = mediaSection[index].innerHTML;
        mediaSection[index].innerHTML = innerHTML
      }
    }

    mediaBtn.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        console.log("dad")
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaBtn_mb.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        console.log("dad")
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaClose.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'add');
        event.stopPropagation();
      });
    });

    document.addEventListener('click', function (event) {
      const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
      const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));

      if (!isClickedInsideBox && !isClickedInsideBtn) {
        mediaPopup.forEach((popup, index) => {
          // popup.classList.add('hide');
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      }
    });

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素已进入视口
          mediaPopup.forEach(item => {
            const iframeEles = item.querySelectorAll('iframe');
            iframeEles.forEach(iframe => {
              const src = iframe.getAttribute('yg-src');
              iframe.setAttribute('src', src);
              iframe.removeAttribute('yg-src');
            })
          })
          // 如果只需要执行一次，可以停止观察
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      // 配置观察选项
      threshold: 0.1, // 当至少50%的元素出现在视口中时，回调函数会被调用
    });
    
    // 选择要观察的目标元素
    const target = this;
    
    // 开始观察目标元素
    observer.observe(target);
  }
}

if (!window.customElements.get('yg-multi-media')) {
  window.customElements.define('yg-multi-media', YGMultiMedia)
}

class YGVideoSwiper extends YGScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    const swiper = this.querySelector('.swiper');

    new Swiper(swiper, {
      loop: false,
      spaceBetween: 30,
      // centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        700: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 3.5,
          spaceBetween: 30
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    })

    const mediaBtn = this.querySelectorAll('.yg-media-box-item');
    const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
    const mediaSection = this.querySelectorAll('.yg-media-box-section');
    const mediaClose = this.querySelectorAll('.yg-media-close');

    function toggleVideoPopup(index, action) {
      mediaPopup[index].classList[action]('hide');
      mediaSection[index]?.classList[action]('hide');
      mediaClose[index].classList[action]('hide');
      if(action === 'remove') {
        let innerHTML = mediaSection[index].innerHTML;
        mediaSection[index].innerHTML = innerHTML
      }
    }

    mediaBtn.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaClose.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'add');
        event.stopPropagation();
      });
    });

    this.addEventListener('click', function (event) {
      const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
      const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));

      if (!isClickedInsideBox && !isClickedInsideBtn) {
        mediaPopup.forEach((popup, index) => {
          // popup.classList.add('hide');
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      }
    });
  }
}

if (!window.customElements.get('yg-video-swiper')) {
  window.customElements.define('yg-video-swiper', YGVideoSwiper)
}

class YGVideo extends HTMLElement {
  constructor() {
    super()
    this.init() // 调用自定义方法
  }

  init() {
    const mediaBtn = this.querySelectorAll('.yg-media-box-item');
    const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
    const mediaSection = this.querySelectorAll('.yg-media-box-section');
    const mediaClose = this.querySelectorAll('.yg-media-close');
    function toggleVideoPopup(index, action) {
      mediaPopup[index].classList[action]('hide');
      mediaSection[index]?.classList[action]('hide');
      mediaClose[index].classList[action]('hide');
      if(action === 'remove') {
        let innerHTML = mediaSection[index].innerHTML;
        mediaSection[index].innerHTML = innerHTML
      }
    }

    mediaBtn.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        console.log("dad")
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaClose.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'add');
        event.stopPropagation();
      });
    });

    this.addEventListener('click', function (event) {
      const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
      const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));

      if (!isClickedInsideBox && !isClickedInsideBtn) {
        mediaPopup.forEach((popup, index) => {
          // popup.classList.add('hide');
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      }
    });

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素已进入视口
          mediaPopup.forEach(item => {
            const iframeEles = item.querySelectorAll('iframe');
            iframeEles.forEach(iframe => {
              const src = iframe.getAttribute('yg-src');
              iframe.setAttribute('src', src);
              iframe.removeAttribute('yg-src');
            })
          })
          // 如果只需要执行一次，可以停止观察
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      // 配置观察选项
      threshold: 0.1, // 当至少50%的元素出现在视口中时，回调函数会被调用
    });
    
    // 选择要观察的目标元素
    const target = this;
    
    // 开始观察目标元素
    observer.observe(target);
  }
}

if (!window.customElements.get('yg-video')) {
  window.customElements.define('yg-video', YGVideo)
}

class YGMegeMenu extends HTMLElement {
  constructor() {
    super()
    this.init() // 调用自定义方法
  }

  init() {
    const megaMenuList = document.querySelectorAll(".yg-mega-menu");
    const imageList = document.querySelectorAll(".yg-image-list img");

    imageList[0].classList.remove('hide');

    megaMenuList.forEach(function (megaMenu){
        const collectionList = megaMenu.querySelectorAll('.yg-menu-hover')
        const collectionContentList = megaMenu.querySelectorAll('.yg-menu-content')
        const imageList = megaMenu.querySelectorAll(".yg-image-list img");
        itemMouseenter(collectionList,collectionContentList,imageList)
    })

    function itemMouseenter(collectionList,collectionContentList,imageList) {
        collectionList.forEach(function (collection,index){
            collection.parentNode.addEventListener("mouseenter",function (){
                collectionList.forEach(function (collection){
                    collection.parentNode.classList.remove("active")
                })
                imageList.forEach((item) => {
                    item.classList.add("hide")
                })
                collection.parentNode.classList.add("active");
                imageList[index].classList.remove("hide")
                collectionContentList.forEach(function (collectionContent){
                    collectionContent.style.display = "none"
                })
                collectionContentList[index].style.display = "flex"
            })
        })
    }
  }
}

if (!window.customElements.get('yg-mege-menu')) {
  window.customElements.define('yg-mege-menu', YGMegeMenu)
}

var YGInfoOffer = class extends YGScriptLoader {
  constructor() {
      super();

      let url = this.getAttribute("data-load-script")
      this.loadScript(url,()=>{
          this.swiper()
      });
  }

  swiper(){
      let swiperItem = this.querySelector('.yg-info-offer')
      new Swiper(swiperItem, {
          spaceBetween: 30,
          centeredSlides: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
      })
  }
}

if (!window.customElements.get('yg-info-offer')) {
  window.customElements.define('yg-info-offer',YGInfoOffer)
}

document.addEventListener("DOMContentLoaded", function () {
  const ygSwitcher = document.querySelector(".yg-switcher-btn");

  if (!ygSwitcher) return

  const currentUrl = window.location.href;
  const btns = ygSwitcher.querySelectorAll('button');
  let hostBtn;
  let flag = false;

  btns.forEach(btn => {
    btn.style.display = 'none';
  })

  btns.forEach(btn => {
    const url = btn.getAttribute('data-url');
    const isDefault = btn.getAttribute('data-default');
    if (isDefault === 'true') {
      hostBtn = btn;
      return
    }
    
    if (url && currentUrl.includes(url)) {
      btn.style.display = 'flex';
      flag = true;
    }
  })
  
  if (!flag) {
    hostBtn.style.display = 'flex'
  }
});